import { Fragment, useEffect, useState } from "react";
import { useMasterCategoryQuery } from "../../../services/categoryApi";

import Select from "react-select";
import customStyles from "./SelectFeild";

import { signInUser } from "../../Utility/Auth";

const SelectMC = ({ mc, handleOnchange, groupId = null, placeholder = "Select Category..." }) => {
  const auth = signInUser();
  const { aamarId } = auth;
  const { data, error, isLoading, isFetching, isSuccess } =
    useMasterCategoryQuery({ aamarId });
  let [mcData, setMcData] = useState([]);

  useEffect(() => {
    let mcs = [];
    if (isSuccess && data && data.length > 0) {
      let filtered = data;
      if (groupId) {
        filtered = data.filter((item) => {
          const itemGroup = typeof item.group === "object" ? item.group?._id : item.group;
          return String(itemGroup) === String(groupId);
        });
      }
      filtered.forEach((item) => {
        mcs.push({
          option: item._id,
          label: `${item.name} - ${item.mcId || item.code || ""}`,
          group: item.group,
        });
      });
      setMcData(mcs);
    } else {
      setMcData([]);
    }
  }, [data, isSuccess, groupId]);

  const selectedValue = mcData.find((obj) => String(obj.option) === String(mc)) || null;

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        isDisabled={false}
        isLoading={isLoading}
        isClearable={true}
        placeholder={placeholder}
        value={selectedValue}
        isSearchable={true}
        name="mc"
        onChange={(selected) => {
          if (handleOnchange) {
            handleOnchange(selected || null);
          }
        }}
        options={mcData}
        styles={customStyles}
      />
    </Fragment>
  );
};

export default SelectMC;
